
import { useState,useRef, useEffect } from 'react';
import { Table,Input,message,Button,Empty,Space,Modal } from 'antd';
import { DataType, column, ExpandedDataType } from './column';
import { afterSalesList,detailList,recharge } from '@/services/afterSales';
import { ResDataType } from '@/services/ajax';
import dayjs from 'dayjs';
import type { TableProps } from 'antd';
import useSearchTable from '@/hooks/useList';
import usePermission from "@/hooks/usePermission";
import usePagAndCommon from '@/hooks/usePagAndCommon';
import BatchCancel from '@/pages/afterSales/component/batchCancel';
import SelectCycleDialog from './component/reissueSelectProdu'
import MenuPermissionControl from '@/components/menuPermissionControl';
import useGetCurMenuId from '@/hooks/useGetCurMenuId';
type TableRowSelection<T extends object = object> = TableProps<T>['rowSelection'];

export default function AfterSalesPage() {
    const { menuId } = useGetCurMenuId();
    const { hasMenuPermission } = usePermission();
    const hasPerm = hasMenuPermission(menuId, 'edit');
    const [flag,setFlag] = useState(false);
    const dialog = useRef<any>(null);
    const selectCycleDialog = useRef<any>(null);
    const [accountModal, setAccountModal] = useState(false);
    const [rechargeParams, setRechargeParams] = useState({
      userRecordId:0,
      collectionAccount:''
    });
    const [selectedRowKeys, setSelectedRowKeys] = useState<DataType[]>([]);
    const [expandDataSource, setExpandDataSource] = useState<ExpandedDataType[]>([]);
    const [selectPriv, setSelectPriv] = useState<DataType | null>();
    const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);
    const defaultValue = {
      Mobile: '',
      OrderId: '',
      CustomerOrderNo: '',
    }
    const {
      data,
      total,
      loading,
      fetchData,
      searchParams,
      handleSearch,
      handlePageChange
    } = useSearchTable(afterSalesList, defaultValue );
    
    const search = (e:any,field:string)=>{
      handleSearch({[field]: e.target.value})
    }

   const onSelectChange = (newSelectedRowKeys: React.Key[],selectedRows:DataType[]) => {
    setSelectedRowKeys(selectedRows);
  };

  const rowSelection: TableRowSelection<DataType> = {
    selectedRowKeys:selectedRowKeys.map((row:DataType) => row.id),
    onChange: onSelectChange,
    getCheckboxProps: (record: DataType) => ({
      disabled: record.status != 1 || !hasPerm
    }),
  };

  const rechargeForRecord = async () => {
    const res = await recharge(rechargeParams) as ResDataType; 
    if (res.code == 0) {
      message.success('充值中');
      getDetailList(selectPriv as DataType);
    } else {
      message.error(res.message);
    }
  }

  const expandedRowRender = () => (
    <Table<ExpandedDataType>
      rowKey="uniqueId"
      columns={[
        ...column('').filter(ite=> ite.title != '下单时间' && ite.key != 'status' && ite.key!='orderId'),
        {
          title: '领取状态',
          dataIndex: 'status',
          key: 'status',
          width: 100,
        },
        {
          title: '领取账号',
          dataIndex: 'collectionAccount',
          key: 'collectionAccount',
          width: 100,
        },
        {
          title: '权益订单号',
          dataIndex: 'mallOrderNo',
          key: 'mallOrderNo',
          render: (_:any,record:ExpandedDataType) => (
            <span>{record.mallOrderNo!='0' && record.mallOrderNo}</span>
          )
        },
        ...otherColumn('createTime'),
        {
          title: '完成时间',
          dataIndex: 'mallOrderFinishTime',
          key: 'mallOrderFinishTime',
          width: 160,
          render(_:string,record:DataType) {
            return (
              <>{record.mallOrderFinishTime && dayjs(record.mallOrderFinishTime ).format("YYYY-MM-DD HH:mm:ss")}</>
            );
          },
        },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 120,
          render: (_:any,record:ExpandedDataType) => (
            <Space size="middle">
              {/* <MenuPermissionControl menuId={menuId} operation="edit" >
                <Button danger disabled={record.status != '未领取' && record.status != '领取失败'} onClick={()=>{
                  selectCycleDialog.current?.open(record,selectPriv);
                }}>补发</Button>
              </MenuPermissionControl> */}
              <MenuPermissionControl menuId={menuId} operation="edit" >
                {/* <Popconfirm
                  title="提示"
                  disabled={record.status == 0}
                  description="确定充值吗?"
                  okText="确定"
                  cancelText="取消"
                  onConfirm={()=> rechargeForRecord(record.id)}
                > */}
                <Button onClick={()=> {
                  setRechargeParams({
                    userRecordId:record.id,
                    collectionAccount:record.collectionAccount,
                  })
                  setAccountModal(true)
                } }  disabled={ record.mallOrderStatus != 6 } danger >充值</Button>
              {/* </Popconfirm> */}
              </MenuPermissionControl>
            </Space>
          ),
        },
      ]}
      dataSource={expandDataSource}
      pagination={false}
      scroll={{ x: 'max-content', y: 280 }}
      locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
    />
  );

  const getDetailList = async (record:DataType) => {
    setFlag(true)
    const res = await detailList(record.id,record.activityId,record.mobile) as ResDataType;
      if (res.code != 0) {
        message.error(res.message);
      } else {
        setExpandDataSource(res.data.list);
        setExpandedRowKeys([record.id]);
        setSelectPriv(record)
      }
      setFlag(false)
  }

const otherColumn = (filed:string='')=>{
  return [
    {
      title: '领取时间',
      dataIndex: filed,
      key: filed,
      width: 160,
    },

    // {
    //   title: '售后时间',
    //   dataIndex: 'afterSaleTime',
    //   key: 'afterSaleTime',
    //   width: 160,
    //   render(_:string,record:DataType) {
    //     return (
    //       <>{record.afterSaleTime && dayjs(record.afterSaleTime ).format("YYYY-MM-DD HH:mm:ss")}</>
    //     );
    //   },
    // },
    // {
    //   title: '售后类型',
    //   dataIndex: 'afterSaleType',
    //   key: 'afterSaleType',
    //   width: 100,
    //   render(_:number,record:DataType) {
    //     return (
    //       <>{record.afterSaleType == 1? '作废' : record.afterSaleType == 2 ? '补发' : ''}</>
    //     );
    //   },
    // },
    {
      title: '充值状态',
      dataIndex: 'mallOrderStatusTxt',
      key: 'mallOrderStatusTxt',
      width: 100,
    },
    // {
    //   title: '售后备注',
    //   dataIndex: 'afterSaleRemark',
    //   key: 'afterSaleRemark',
    //   width: 100,
    // }
  ]
}
const clearData = () => {
  setExpandedRowKeys([]);
  setSelectPriv(null);
  setExpandDataSource([]); 
}

useEffect(() => {
  data.length == 0 && clearData(); 
},[data])

const handleExpanded = async (record:DataType) => {
    if (expandedRowKeys[0] == record.id) {
      clearData();
    } else {
      getDetailList(record);
    }
  };

  const confirmAccount = async() => {
    if (!rechargeParams.collectionAccount) {
      message.error('请输入领取账号');
      return;
    }
    await rechargeForRecord();
    setAccountModal(false);
  }

  return (
    <>
      <div className="headerTitle">
        <div>
          <h2>售后管理</h2>
        </div>
      </div>

      <div className="card">
        <div className="searchCond" style={{ width:'55%' }}>
          <Space size='middle'>
            <Input allowClear placeholder="手机号" onPressEnter={(e)=> {search(e,'Mobile')}} size='large' onChange={(e)=> {search(e,'Mobile')}}/>
            <Input allowClear placeholder="主订单号" onPressEnter={(e)=> {search(e,'OrderId')}} size='large' onChange={(e)=> {search(e,'OrderId')}}/>
            <Input allowClear placeholder="店铺订单号" onPressEnter={(e)=> {search(e,'CustomerOrderNo')}} size='large' onChange={(e)=> {search(e,'CustomerOrderNo')}}/>
            <Button type="primary" size='large' onClick={()=>{ fetchData();selectPriv && getDetailList(selectPriv as DataType) }}>搜索</Button>
            
            <MenuPermissionControl menuId={menuId} operation="edit" >
              <Button danger size='large' disabled={selectedRowKeys.length === 0} onClick={()=>{ 
                const cancelList = selectedRowKeys.map((row:DataType) => {
                  return { userActivityId: row.id, refundAmount: 0, remark: '',name: row.name }
                })
                dialog.current?.open(cancelList)
              }}>批量作废</Button>
             </MenuPermissionControl>
          </Space>
        </div>

        <div className="overflow-x-auto">
          <Table<DataType> rowKey='id'
          rowSelection={rowSelection}
          columns={[
            ...column('createTime').filter(ite=> ite.key!='productName'),
            {
              title: '店铺订单号',
              dataIndex: 'customerOrderNo',
              key: 'customerOrderNo', 
            },
            ...otherColumn(),
            {
              title: '操作',
              key: 'action',
              fixed: 'right',
              render: (_, record) => (
                <Space size="middle">
                    <Button type="link" onClick={()=>{
                      handleExpanded(record)
                    }}>{ expandedRowKeys[0] == record.id ? '收起' : '展开'  }</Button>
                  <MenuPermissionControl menuId={menuId} operation="edit" >
                    <Button danger disabled={record.status!=1} onClick={()=>{
                      dialog.current?.open([{
                        userActivityId: record.id, refundAmount: 0, remark: '',name: record.name,
                      }]);
                    }}>作废</Button>
                  </MenuPermissionControl>
                </Space>
              ),
            },
          ]} 
          dataSource={data as DataType[]}
          loading={loading || flag}
          pagination={{ current: searchParams.PageIndex, pageSize:searchParams.PageSize, total, onChange: handlePageChange,showSizeChanger:false  }}
          scroll={{ x: 'max-content', y: 580 }}
          expandable={{ expandedRowRender,expandedRowKeys,showExpandColumn:false }}
          locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
          />
        </div>
      </div>
      <BatchCancel ref={dialog} save={handleSearch} />
      <SelectCycleDialog ref={selectCycleDialog} save={getDetailList} />
      <Modal open={accountModal} maskClosable={false} title='请确认领取账号(手机号或产品对应的账号)' okText='确定' cancelText="取消" onOk={confirmAccount} onCancel={()=> setAccountModal(false)}>
          <div>
              <span>领取账号：</span><Input placeholder={`请输入`} onFocus={(e)=> e.target.select()} value={rechargeParams.collectionAccount} onChange={(e)=> setRechargeParams(prev=>{
                return { ...prev, collectionAccount: e.target.value }
              })} />
          </div>
      </Modal>
    </>
  );
} 